import {
  ComponentRef,
  InjectionToken,
  ViewContainerRef,
  ɵDirectiveDef as DirectiveDef,
  ɵNG_COMP_DEF as NG_COMP_DEF,
} from '@angular/core';

export type RtButtonVariant =
  | 'primary'
  | 'secondary'
  | 'outlined'
  | 'plain'
  | 'success'
  | 'error'
  | 'warning';

export type RtPlanButtonVariant = 'scale' | 'lead';

export const setInputs = <
  T extends ComponentRef<any>,
  U extends { [k in keyof T['instance']]: T['instance'][k] },
>(
  componentRef: T,
  props: Partial<U>,
) => {
  const { componentType, instance, changeDetectorRef } = componentRef;
  const directiveDef = <DirectiveDef<T['componentType']>>(<any>componentType)[NG_COMP_DEF];
  Object.entries(props).forEach(([prop, value]) => {
    if (directiveDef.setInput) {
      directiveDef.setInput(instance, value, prop, prop);
    } else {
      instance[prop] = value;
    }
  });
  changeDetectorRef.detectChanges();
};

export abstract class ExtendableButton {
  public primarySlot: ViewContainerRef;
  public secondarySlot: ViewContainerRef;

  public abstract addClass(name: string[]): void;
  public abstract removeClass(name: string[]): void;
}

export const ExtendableButtonToken = new InjectionToken<ExtendableButton>('ExtendableButton');
